import { memo } from "react";
import { useTranslate } from "helpers";
import { Button } from "ui/components/Button/Button";

interface TireEmptyStateProps {
    onAdd: () => void;
    error?: string;
}

const TireEmptyState: React.FC<TireEmptyStateProps> = (props) => {
    const { onAdd, error } = props;
    const { t } = useTranslate();

    return (
        <div className="relative mb-3">
            <div className="max-w-md mx-auto text-center">
                <Button
                    variant="primary"
                    children={t("admin.fleet.tire.set.add.tiretoset")}
                    onClick={onAdd}
                    startIcon="/media/icons/plus.svg"
                    size="full"
                />
                {error && <p className="mt-3 text-sm text-red-600">{error}</p>}
            </div>
        </div>
    );
};

export default memo(TireEmptyState);
